export const baseUrl =
  window.location.hostname === 'localhost'
    ? 'http://localhost:8000'
    : `https://api.${window.location.hostname.slice(7)}`;

export const clientUrl =
  window.location.hostname === 'localhost'
    ? 'http://localhost:3000'
    : `https://${window.location.hostname.slice(7)}`;

// export const baseUrl = `https://f168-api.domain-demo.online`;
// export const clientUrl = `https://f168.domain-demo.online`;

export const formatDateTime = (time) => {
  let data = new Date(isNaN(time) ? time : Number(time));
  let dd = data.getDate();
  let MM = data.getMonth() + 1;
  let yy = data.getFullYear();
  let hh = data.getHours();
  let mm = data.getMinutes();
  let ss = data.getSeconds();
  if (dd < 10) dd = `0${dd}`;
  if (MM < 10) MM = `0${MM}`;
  if (hh < 10) hh = `0${hh}`;
  if (mm < 10) mm = `0${mm}`;
  if (ss < 10) ss = `0${ss}`;
  return `${yy}-${MM}-${dd} ${hh}:${mm}:${ss}`;
};

export const getDevice = () => {
  return localStorage.getItem('device');
};

export const formatNumber = (number = 0) => new Intl.NumberFormat().format(number);
